
import React from 'react';
import { HelpCircle, ChevronDown } from 'lucide-react';

const FAQs: React.FC = () => {
  const faqs = [
    { q: "Are the notes on EduZone.pk free?", a: "Yes, 100% free. We believe every student in Pakistan deserves access to high-quality study materials without any hidden charges." },
    { q: "How can I get the notes?", a: "Simply navigate to your class (e.g., Class 9), click on the subject, and hit the 'Contact at WhatsApp' button. Our team will provide you with the latest notes and updates directly on your phone." },
    { q: "Are these notes valid for the 2024-2025 academic session?", a: "Absolutely. We update our content regularly to match the latest All Board Curriculum and Textbook Board (PCTB) and BISE Lahore patterns." },
    { q: "When will full notes be uploaded?", a: "We are currently in the 'Beta Phase' where we've uploaded sample notes to get student feedback. Full notes for all subjects are scheduled to be released over the next few months." },
    { q: "Does EduZone provide past papers?", a: "We are working on a dedicated 'Past Paper Gallery' which will feature the last 10 years of solved papers for BISE Lahore and other All boards." },
    { q: "Can I use these notes for other boards like Multan or Gujranwala?", a: "Yes! All All Boards (Lahore, Gujranwala, Multan, Rawalpindi, Sahiwal, Sargodha, Faisalabad, DG Khan, Bahawalpur) follow the same curriculum." }
  ];

  return (
    <div className="bg-gray-50 min-h-screen py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="bg-blue-600 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-8 shadow-2xl">
            <HelpCircle size={40} className="text-white" />
          </div>
          <h1 className="text-4xl font-extrabold text-slate-900 mb-4">Frequently Asked Questions</h1>
          <p className="text-lg text-slate-600">Got questions? We've got answers. Everything you need to know about the EduZone platform.</p>
        </div>

        <div className="space-y-6">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-8 hover:shadow-md transition">
              <h3 className="text-xl font-bold text-slate-900 mb-4 flex justify-between items-center cursor-pointer">
                {faq.q}
              </h3>
              <p className="text-slate-600 leading-relaxed text-lg border-t border-gray-50 pt-4">
                {faq.a}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-slate-900 rounded-3xl p-12 text-center text-white">
          <h2 className="text-2xl font-bold mb-4">Still have questions?</h2>
          <p className="text-slate-400 mb-8">If you didn't find the answer you're looking for, feel free to reach out to our support team.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="mailto:info@eduzone.pk" className="bg-blue-600 px-8 py-3 rounded-xl font-bold hover:bg-blue-700 transition">Email Support</a>
            <a href="https://wa.me/923294349972" className="bg-green-600 px-8 py-3 rounded-xl font-bold hover:bg-green-700 transition">WhatsApp Us</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQs;
